import { addMessages } from '@hana/i18n';

// Khoá chuỗi clst.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'clst.1': "Kỳ 10/2026",
  'clst.2': "Tháng này · 01–31/Oct/2026 ▾",
  'clst.3': "Lọc",
  'clst.4': "Tổng HĐ",
  'clst.5': "Chưa ghép",
  'clst.6': "Chênh dự kiến",
  'clst.7': "GP quản trị",
  'clst.8': "Có cảnh báo",
});
addMessages('en', {
  'clst.1': "Period 10/2026",
  'clst.2': "This month · 01–31/Oct/2026 ▾",
  'clst.3': "Filter",
  'clst.4': "Total invoices",
  'clst.5': "Unmatched",
  'clst.6': "Expected variance",
  'clst.7': "Management GP",
  'clst.8': "With warnings",
});
